/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import * as actionTypes from '../../constants/actions';

const providers = ['https://geoip.nekudo.com/api/'];

const getClientLocation = (retry = 0) =>
  new Promise((resolve) => {
    if (!providers[retry]) {
      return resolve({});
    }
    return axios
      .get(providers[retry])
      .then((response) => {
        if (!response || !response.data || response.status !== 200) {
          /* eslint no-param-reassign: "off" */
          retry += 1;
          return getClientLocation(retry).then(resolve);
        }
        const location = {
          region: response.data.region_name || response.data.city || '',
          city: response.data.city || '',
          country:
            response.data.country_name || response.data.country.name || '',
        };
        return resolve(location);
      })
      .catch(() => {
        retry += 1;
        return getClientLocation(retry).then(resolve);
      });
  });

export const fetchLocation = () => (dispatch) => {
  getClientLocation().then((location) => {
    dispatch({
      type: actionTypes.FETCH_LOCATION,
      status: 'success',
      location,
    });
  });
};
